/**
 * DTOs de cuentas y correo (`/account/*`, docs/FASE-1.md §4): recuperación de contraseña y
 * primer acceso por invitación. Las rutas son formularios HTML, no JSON — estos esquemas validan
 * el cuerpo ya parseado por `express.urlencoded()` antes de tocar la lógica de negocio, igual que
 * `oidc/validation.ts` hace con `/login`.
 */
import { z } from "zod";
/**
 * Política mínima de contraseñas elegidas por el propio usuario. Ningún otro documento de fase 0
 * o fase 1 fija una regla de longitud/composición (el login solo la compara contra el hash
 * guardado), así que se adopta un mínimo razonable de 10 caracteres, sin exigir composición
 * (mayúsculas/símbolos): la longitud es el factor que más aporta y evita reglas arbitrarias que
 * solo frustran a usuarios reales.
 */
export const NewPasswordSchema = z
    .string()
    .min(10, "La contraseña debe tener al menos 10 caracteres.")
    .max(200, "La contraseña es demasiado larga.");
/** `POST /account/forgot`: siempre responde igual, exista o no la cuenta (docs/FASE-1.md §4). */
export const RequestPasswordResetInputSchema = z.object({
    email: z.email(),
});
/** `POST /account/reset`: fija la contraseña nueva y consume el token de `purpose: password_reset`. */
export const ResetPasswordInputSchema = z.object({
    token: z.string().min(1),
    password: NewPasswordSchema,
});
/** `POST /account/invite`: primer acceso del usuario invitado, consume el token de `purpose: invitation`. */
export const AcceptInvitationInputSchema = z.object({
    token: z.string().min(1),
    password: NewPasswordSchema,
});
//# sourceMappingURL=accounts.js.map